// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components----Hero-module---root---1C9S3","container":"src-components----Hero-module---container---cLlSk","withImage":"src-components----Hero-module---withImage----xxjy","title":"src-components----Hero-module---title---2kqQp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Hero.module.scss
// module id = ./src/components/Hero.module.scss
// module chunks = 168707334958949